import { Box, Button, CircularProgress, Dialog, DialogActions, DialogContent, DialogTitle, FormControl, FormControlLabel, makeStyles, Paper, Switch, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, TextField, Typography } from '@material-ui/core'
import * as React from 'react'
import { useQuery } from 'react-query'
import { StyledTableCell } from '../../components/CustomTable';
import { useFeedback } from '../../components/Feedback';
import NationalCodeSelect from '../../components/NationalCodeSelect';
import { createCoaching, listCoach, saveCoach } from '../../utils/api'
import { useDropzone } from 'react-dropzone';
import { cos } from '../../utils/cos'
import Cropper from 'react-cropper';
import 'cropperjs/dist/cropper.css';

const useStyles = makeStyles({
    table: {
        minWidth: 650,
        backgroundColor: '#fff'
    },
    addBox: {
        display: 'flex',
        alignItems: 'center'
    }
});

const Coach = () => {
    const { data: coachs, refetch } = useQuery('listcoachforadmin', () => listCoach())
    const classes = useStyles()
    const [showAddOneOnOne, setShowOneOnOne] = React.useState(false)
    const [showAddCoach, setShowAddCoach] = React.useState(false)
    const { showToast, showLoading, hideLoading } = useFeedback()
    const [uploadImg, setUploadImg] = React.useState(false)
    const [uploadIntroPhoto,setUploadIntroPhoto] = React.useState(false)
    const [localCropper, setlocalCropper] = React.useState({
        src: '',
        filename: '',
        showEdit: false
    })
    const [cropperStart, setCropperStart] = React.useState(false)

    const { acceptedFiles, getRootProps, getInputProps } = useDropzone()
    const { acceptedFiles: introFiles, getRootProps: getIntroRootProps, getInputProps: getIntroInputProps } = useDropzone()

    const handleUpload = (files: File[]) => {
        if (!files || files.length < 1) {
            return;
        }
        const file = files[files.length - 1]
        const filename = Date.now() + file.name.substr(file.name.lastIndexOf('.'))
        doUploadImg(file, filename, 1)
    }

    const doUploadImg = (file: Blob, filename: string, type: Number) => {
        //type 1 拖拽上传， 2 裁剪保存

        setUploadImg(true)
        cos.sliceUploadFile({
            Bucket: 'video-1302643710', /* 必须 */
            Key: 'img/avatar/coach/' + filename,              /* 必须 */
            Body: file,
            Region: 'ap-beijing',
            onTaskReady: function (taskId: any) {                   /* 非必须 */
                console.log(taskId);
            },
            onHashProgress: function (progressData: any) {       /* 非必须 */
                console.log(JSON.stringify(progressData));
            },
            onProgress: function (progressData: any) {           /* 非必须 */
                console.log(JSON.stringify(progressData));
            }
        }, (err: any, data: any) => {
            console.log(err || data);
            setUploadImg(false)
            if (!err) {
                setCoach({ ...coach, avatar: `https://res.add-coach.com/${data.Key}` })
                if (type == 1) {

                    setCropperStart(false)
                    setlocalCropper({
                        ...localCropper,
                        src: `https://res.add-coach.com/${data.Key}`,
                        showEdit: true
                    })
                }
            } else {
                showToast('封面图上传失败，请重试')
            }
        })
    }

    const uploadImage = (file: File, filename: string) => new Promise<string>((resolve, reject) => {
        cos.sliceUploadFile({
            Bucket: 'video-1302643710', /* 必须 */
            Key: 'img/avatar/coach/' + filename,              /* 必须 */
            Body: file,
            Region: 'ap-beijing',
        }, (err: any, data: any) => {
            if (!err) {
                resolve(`https://res.add-coach.com/${data.Key}`)
            } else {
                reject(err)
            }
        })
    })

    React.useEffect(() => {
        handleUpload(acceptedFiles)
    }, [acceptedFiles])

    React.useEffect(() => {
        if (introFiles && introFiles.length > 0) {
            const file = introFiles[introFiles.length - 1]
            const filename = Date.now() + file.name.substr(file.name.lastIndexOf('.'))
            setUploadIntroPhoto(true)
            uploadImage(file, filename).then(res => {
                setUploadIntroPhoto(false)
                setCoach({...coach,introduction_photo: res})
            }).catch(e => {
                setUploadIntroPhoto(false)
                showToast('上传失败')
            })
        }
    }, [introFiles])

    const [coach, setCoach] = React.useState<Coach>({
        name: '',
        mobile: '',
        wechat: '',
        introduction: '',
        initial_interview: 0,
        one_on_one_coaching: 0,
        group_coaching: 0,
        price: 0,
        price_discount_6: 0,
        price_discount_level1: 0,
        price_discount_level2: 0,
        avatar: '',
        username: '',
        password: ''
    })

    const [oneOnOne, setOneOnOne] = React.useState({
        coachId: '',
        coachName: '',
        mobile: '',
        number: '',
        nationalCode: '86',
        name: ''
    })

    const handleAddOneOnOne = (coach: Coach) => () => {
        setOneOnOne({ coachId: `${coach.user_id}`, coachName: coach.name, mobile: '', number: '', nationalCode: '86', name: '' })
        setShowOneOnOne(true)
    }

    const handleCreateCoaching = () => {
        if (!oneOnOne.name) {
            showToast('请输入来访者姓名')
            return;
        }
        if (!oneOnOne.mobile) {
            showToast('请输入手机号')
            return;
        }
        if (!(+oneOnOne.number)) {
            showToast('请输入训练次数')
            return;
        }
        showLoading('')
        createCoaching(oneOnOne.name, oneOnOne.mobile, oneOnOne.nationalCode, oneOnOne.number, oneOnOne.coachId).then(res => {
            hideLoading()
            if (res.data === 'success') {
                showToast('添加成功')
                setShowOneOnOne(false)
            } else {
                showToast('添加失败')
            }
        }).catch(e => {
            hideLoading()
            showToast('添加失败')
        })
    }

    const handleOneOnOneChange = (key: 'name' | 'nationalCode' | 'mobile' | 'number') => (event: React.ChangeEvent<HTMLInputElement>) => {
        setOneOnOne({ ...oneOnOne, [key]: event.target.value })
    }

    const handleEditCoach = (c: Coach) => () => {
        setCoach(c)
        setShowAddCoach(true)
    }

    const handleAddCoach = () => {
        setCoach({
            name: '',
            mobile: '',
            wechat: '',
            introduction: '',
            initial_interview: 0,
            one_on_one_coaching: 0,
            group_coaching: 0,
            price: 0,
            price_discount_6: 0,
            price_discount_level1: 0,
            price_discount_level2: 0,
            avatar: '',
            username: '',
            password: ''
        })
        setShowAddCoach(true)
    }

    const handleCoachChange = (key: string) => (event: React.ChangeEvent<HTMLInputElement>, checked?: boolean) => {
        let value = event.target.value
        if (key === 'one_on_one_coaching' || key === "initial_interview" || key === "group_coaching") {
            value = checked ? '1' : '0'
        }
        if (key === 'price' || key === 'price_discount_level1' || key === 'price_discount_level2' || key === 'price_discount_6') {
            if (+value < 1) {
                value = ''
            }
        }
        setCoach({ ...coach, [key]: value })
    }

    const handleSaveCoach = () => {
        saveCoach(coach).then(res => {
            if (res.data.type === 'success') {
                showToast('提交成功')
                setShowAddCoach(false)
                refetch()
            } else {
                showToast('提交失败，' + res.data.message)
            }
        }).catch(e => {
            showToast('提交失败，请重试')
        })
    }
    const cropperRef = React.useRef<HTMLImageElement>(null);
    const onCrop = () => {
        const imageElement: any = cropperRef?.current;
        const cropper: any = imageElement?.cropper;
    };
    const cropStart = () => {
        setCropperStart(true)
    }
    const cropStop = () => {
        setlocalCropper({
            src: '',
            filename: '',
            showEdit: false
        })
        setCropperStart(false)
        setShowAddCoach(false)
    }
    const cropIni = () => {
        let src = localCropper.src
        if (src == "") { src = coach.avatar }
        setlocalCropper({ ...localCropper, showEdit: true, src: src })
        setCropperStart(false)

    }
    const cropImage = () => {
        const imageElement: any = cropperRef?.current;
        const cropper: any = imageElement?.cropper;
        const avatar = cropper.getCroppedCanvas()
        if (avatar === 'null') {
            return false
        }
        setCoach({ ...coach, avatar: cropper.getCroppedCanvas().toDataURL() })
        setlocalCropper({ ...localCropper, showEdit: false })
        avatar.toBlob((blob: Blob) => {
            const filename = Date.now() + '.jpg'
            doUploadImg(blob, filename, 2)
        }, "image/jpeg")
    }

    return <React.Fragment>
        <Button onClick={handleAddCoach}>添加教练</Button>
        <Box mt={1}>
            <TableContainer component={Paper} style={{ backgroundColor: '#fff', marginTop: '20px' }}>
                <Table className={classes.table}>
                    <TableHead>
                        <TableRow>
                            <StyledTableCell width="50px"></StyledTableCell>
                            <StyledTableCell>姓名</StyledTableCell>
                            <StyledTableCell>首次约谈次数</StyledTableCell>
                            <StyledTableCell>1对1教练次数</StyledTableCell>
                            <StyledTableCell>手机号</StyledTableCell>
                            <StyledTableCell>微信号</StyledTableCell>
                            <StyledTableCell>首次约谈</StyledTableCell>
                            <StyledTableCell>1对1教练</StyledTableCell>
                            <StyledTableCell>团体教练</StyledTableCell>
                            <StyledTableCell>1对1教练收费价格</StyledTableCell>
                            <StyledTableCell>简介</StyledTableCell>
                            <StyledTableCell align="center">操作</StyledTableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {
                            coachs?.map(coach => <TableRow>
                                <TableCell><img src={coach.avatar} width="48px" height="48px" style={{ objectFit: 'cover' }} /></TableCell>
                                <TableCell>{coach.name}</TableCell>
                                <TableCell style={{ backgroundColor: '#f1f1f1' }}>{coach.initial_interview_count}</TableCell>
                                <TableCell style={{ backgroundColor: '#f1f1f1' }}>{coach.one_on_one_count}</TableCell>
                                <TableCell>{coach.mobile}</TableCell>
                                <TableCell>{coach.wechat}</TableCell>
                                <TableCell>{coach.initial_interview ? 'Yes' : 'No'}</TableCell>
                                <TableCell>{coach.one_on_one_coaching ? 'Yes' : 'No'}</TableCell>
                                <TableCell>{coach.group_coaching ? 'Yes' : 'No'}</TableCell>
                                <TableCell>
                                    <Typography variant="body2">3次以下:{coach.price}</Typography>
                                    <Typography variant="body2">3-5次:{coach.price_discount_level1}</Typography>
                                    <Typography variant="body2">6次及以上:{coach.price_discount_level2}</Typography>
                                    <Typography variant="body2">特惠价:{coach.price_discount_6}</Typography>
                                </TableCell>
                                <TableCell>{coach.introduction}</TableCell>
                                <TableCell align="center">
                                    <Button variant="contained" size="small" onClick={handleEditCoach(coach)}>编辑</Button>
                                    {!!coach.one_on_one_coaching && <Button style={{ marginLeft: '8px' }} size="small" variant="contained" onClick={handleAddOneOnOne(coach)}>插入1对1教练任务</Button>}
                                </TableCell>
                            </TableRow>)
                        }
                    </TableBody>
                </Table>
            </TableContainer>
        </Box>

        <Dialog open={showAddCoach} maxWidth="lg" onClose={cropStop}>
            <DialogTitle>{coach.user_id ? '编辑教练' : '添加教练'}</DialogTitle>
            <DialogContent>
                {!coach.user_id && <Box>
                    <Typography>登录账号</Typography>
                    <form autoComplete="off">
                        <Box mt={1}>
                            <TextField disabled={!!coach.user_id} value={coach.username} onChange={handleCoachChange('username')} name="u" autoComplete="off" label="账号" size="small" variant="outlined" />
                            <TextField value={coach.password} onChange={handleCoachChange('password')} name="p" autoComplete="new-password" type="password" style={{ marginLeft: '8px' }} label="密码" size="small" variant="outlined" />
                        </Box>
                    </form>
                </Box>}
                <Box mt={2}>
                    <Typography>基本信息</Typography>
                    <Box width="80px" height="80px" mt={1} position="relative">
                        <div {...getRootProps({ className: 'dropzone' })} style={{ minHeight: '80px', height: '80px', padding: '12px', border: '1px dashed #e1e1e1', borderRadius: '4px' }}>
                            <input {...getInputProps()} />
                            <Typography variant="caption" align="center">点击或拖头像至此</Typography>
                        </div>
                        {coach.avatar && <img src={coach.avatar} style={{ position: 'absolute', top: '0', left: '0', pointerEvents: 'none', objectFit: 'cover', cursor: 'pointer', width: '100%', height: '100%' }} />}
                        {uploadImg && <Box display="flex" alignItems="center" justifyContent="center" style={{ position: 'absolute', top: '0', left: '0', width: '100%', height: '100%' }}>
                            <CircularProgress size={24} />
                        </Box>}
                    </Box>

                    {!!+localCropper.showEdit && <Box mt={2} position="relative">
                        <Cropper
                            src={localCropper.src}
                            style={{ height: 400, width: 400 }}
                            initialAspectRatio={1}
                            aspectRatio={1}
                            guides={false}
                            dragMode="move"
                            preview=".img-preview"
                            crop={onCrop}
                            ready={cropStart}
                            ref={cropperRef} />
                        {!cropperStart && <Box display="flex" alignItems="center" justifyContent="center" style={{ position: 'absolute', top: '0', left: '0', width: '100%', height: '100%' }}>
                            <CircularProgress size={64} />
                        </Box>}
                        <div style={{ width: '80px', position: 'absolute', top: '320px', left: '420px', height: '80px', overflow: 'hidden' }}>
                            <div className="img-preview" style={{ width: '80px', height: '80px' }}></div>
                        </div>
                        <Box mt={2}>
                            <Button onClick={cropImage} >确认使用</Button>
                        </Box>
                    </Box>}
                    {!+localCropper.showEdit && coach.avatar && <Box mt={2} position="relative">
                        <Box mt={2}>
                            <Button onClick={cropIni} >编辑头像</Button>
                        </Box>
                    </Box>}
                    <Box mt={2}>
                        <TextField value={coach.name} onChange={handleCoachChange('name')} label="姓名" size="small" variant="outlined" />
                        <TextField value={coach.mobile} onChange={handleCoachChange('mobile')} style={{ marginLeft: '8px' }} label="手机号" size="small" variant="outlined" />
                        <TextField value={coach.wechat} onChange={handleCoachChange('wechat')} style={{ marginLeft: '8px' }} label="微信号" size="small" variant="outlined" />
                    </Box>
                    <Box mt={2}>
                        <TextField value={coach.introduction} onChange={handleCoachChange('introduction')} label="简介" variant="outlined" fullWidth size="small" />
                    </Box>

                    <Box mt={2}>
                        <Typography variant="subtitle2">教练简介图片</Typography>
                        <Box width="100px" height="100px" mt={1} position="relative">
                            <div {...getIntroRootProps({ className: 'dropzone' })} style={{ minHeight: '80px', height: '100px', padding: '12px', border: '1px dashed #e1e1e1', borderRadius: '4px' }}>
                                <input {...getIntroInputProps()} />
                                <Typography variant="caption" align="center">点击或拖教练简介图片至此</Typography>
                            </div>
                            {coach.introduction_photo && <img src={coach.introduction_photo} style={{ position: 'absolute', top: '0', left: '0', pointerEvents: 'none', objectFit: 'cover', cursor: 'pointer', width: '100%', height: '100%' }} />}
                            {uploadIntroPhoto && <Box display="flex" alignItems="center" justifyContent="center" style={{ position: 'absolute', top: '0', left: '0', width: '100%', height: '100%' }}>
                                <CircularProgress size={24} />
                            </Box>}
                        </Box>
                    </Box>
                </Box>
                <Box mt={2}>
                    <Typography>教练职能</Typography>
                    <Box mt={1}>
                        <FormControlLabel label="首次约谈" labelPlacement="start" control={<Switch checked={!!+coach.initial_interview} onChange={handleCoachChange('initial_interview')} />} />
                        <FormControlLabel label="1对1教练" labelPlacement="start" control={<Switch checked={!!+coach.one_on_one_coaching} onChange={handleCoachChange('one_on_one_coaching')} />} />
                        <FormControlLabel label="团体教练" labelPlacement="start" control={<Switch checked={!!+coach.group_coaching} onChange={handleCoachChange('group_coaching')} />} />
                    </Box>
                </Box>
                {!!+coach.one_on_one_coaching && <Box mt={2}>
                    <Typography>1对1教练收费价格</Typography>
                    <Box mt={1}>
                        <TextField value={coach.price ? coach.price : ''} onChange={handleCoachChange('price')} style={{ marginRight: '8px' }} label="3次以下" size="small" variant="outlined" />
                        <TextField value={coach.price_discount_level1 ? coach.price_discount_level1 : ''} onChange={handleCoachChange('price_discount_level1')} style={{ marginRight: '8px' }} label="3-5次" size="small" variant="outlined" />
                        <TextField value={coach.price_discount_level2 ? coach.price_discount_level2 : ''} onChange={handleCoachChange('price_discount_level2')} style={{ marginRight: '8px' }} label="6次及以上" size="small" variant="outlined" />
                        <TextField value={coach.price_discount_6 ? coach.price_discount_6 : ''} onChange={handleCoachChange('price_discount_6')} label="特惠价" size="small" variant="outlined" />
                    </Box>
                </Box>}
            </DialogContent>
            <DialogActions >
                <Button onClick={handleSaveCoach}>确定</Button>
            </DialogActions>
        </Dialog>
        <Dialog open={showAddOneOnOne} maxWidth="lg" onClose={() => setShowOneOnOne(false)}>
            <DialogTitle>添加1对1教练</DialogTitle>
            <DialogContent>
                <Box>
                    <Typography>教练：{oneOnOne.coachName}</Typography>
                    <Box mt={2}>
                        <TextField value={oneOnOne.name} onChange={handleOneOnOneChange('name')} style={{ marginLeft: '8px', marginRight: '8px' }} label="来访者姓名" />
                        <TextField
                            value={oneOnOne.mobile} onChange={handleOneOnOneChange('mobile')}
                            InputProps={{ startAdornment: <NationalCodeSelect onChange={handleOneOnOneChange('nationalCode')} value={oneOnOne.nationalCode} /> }}
                            type="tel"
                            style={{ marginLeft: '8px', marginRight: '8px' }}
                            label="手机号"
                        />
                        <TextField value={oneOnOne.number} onChange={handleOneOnOneChange('number')} type="number" style={{ marginLeft: '8px', marginRight: '8px' }} label="教练次数" />
                    </Box>
                    <Box mt={2} textAlign="center">
                        <Button onClick={handleCreateCoaching} >提交</Button>
                    </Box>
                </Box>
            </DialogContent>
        </Dialog>
    </React.Fragment>
}

export default Coach